import { render, staticRenderFns } from "./SingleZoneSmall.vue?vue&type=template&id=31a8f067&scoped=true&"
import script from "./SingleZoneSmall.vue?vue&type=script&lang=js&"
export * from "./SingleZoneSmall.vue?vue&type=script&lang=js&"
import style0 from "./SingleZoneSmall.vue?vue&type=style&index=0&id=31a8f067&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a8f067",
  null
  
)

export default component.exports